module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-1-5963a77d1c67788ea41f6a708f53e311.png";